export type LanguageType = "pt" | "en" | "es";

export const getCurrentSystemLanguage = (): LanguageType => {
  const SYSTEM_LOCALE = navigator.language;

  switch (true) {
    case SYSTEM_LOCALE.startsWith("pt"):
      return "pt";
    case SYSTEM_LOCALE.startsWith("en"):
      return "en";
    case SYSTEM_LOCALE.startsWith("es"):
      return "es";
    default:
      return "pt";
  }
};

export const getCurrentLanguageFromStorage = (): LanguageType => {
  const CURRENT_LANGUAGE_I18NEXT = localStorage.getItem("i18nextLng");

  switch (true) {
    case CURRENT_LANGUAGE_I18NEXT?.startsWith("pt"):
      return "pt";
    case CURRENT_LANGUAGE_I18NEXT?.startsWith("en"):
      return "en";
    case CURRENT_LANGUAGE_I18NEXT?.startsWith("es"):
      return "es";
    default:
      return "pt";
  }
};

export const getDefaultLanguage = () =>
  getCurrentLanguageFromStorage() ?? getCurrentSystemLanguage();

export const getLocaleByLanguage = () => {
  const language = getDefaultLanguage();
  switch (language) {
    case "en":
      return "en-US";
    case "es":
      return "es-ES";

    default:
      return "pt-BR";
  }
};
